'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NitroBadge = require('./NitroBadge');

var _NitroBadge2 = _interopRequireDefault(_NitroBadge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _NitroBadge2.default;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-badge/index.js
// module id = 103
// module chunks = 4